import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHandshake, faCheck } from '@fortawesome/free-solid-svg-icons';
import './Financiacion.css';
import { Link } from 'react-router-dom';

export default function Financiacion() {
    const pasos = [
        {
            icon: faSearch,
            titulo: "Elegís el auto que te gusta",
            descripcion: "Visitá nuestro catálogo para ver tu auto ideal."
        },
        {
            icon: faHandshake,
            titulo: "Nos contactás y te asesoramos",
            descripcion: "Gestionamos el crédito más accesible según tu caso. También podés entregar tu vehículo usado, y muchas otras formas de pago."
        },
        {
            icon: faCheck,
            titulo: "¡Felicitaciones!",
            descripcion: "Hacemos los trámites y te vas en tu auto nuevo."
        }
    ];

    const handleFinanciarClick = () => {
        console.log('Iniciando proceso de financiación');
    };

    return (
        <div className='financiacion-section'>
            <div className='financiacion-container'>
                <div className='financiacion-header'>
                    <h2 className='financiacion-title'>FINANCIA TU AUTO</h2>
                    <p className='financiacion-subtitle'>
                        Gestionamos créditos de forma fácil y a la tasa más conveniente.
                    </p>
                </div>

                <div className='pasos-grid'>
                    {pasos.map((paso, index) => (
                        <div
                            key={index}
                            className='paso-item'
                            style={{ '--delay': `${index * 0.2}s` }}
                        >
                            {/* Icono del paso */}
                            <div className='paso-icono'>
                                <FontAwesomeIcon icon={paso.icon} size="2x" />
                            </div>

                            <div className='paso-content'>
                                <h3 className='paso-titulo'>{paso.titulo}</h3>
                                <p className='paso-descripcion'>{paso.descripcion}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='financiacion-cta'>
                    <Link
                        to="/financiacion"
                        className='financiar-btn'
                        onClick={handleFinanciarClick}
                    >
                        Quiero financiar mi auto
                        <span className='btn-arrow'>→</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}
